import React, { useContext, useEffect, useState } from 'react'
import { QuickOrderContext } from '../../../../context/QuickOrderContext'
import NewGutterItem from './GutterItem/NewGutterItem'
import NewGutterMitreItem from './GutterItem/NewGutterMitre'
import NewStopEndBracketItem from './GutterItem/NewStopEndBracketItem'
import { getUniqueIdWithPrefix } from '../../../../../_metronic/assets/ts/_utils'
import { ORDER_LIST_RAINWATERGOODS, ORDER_TAB_RAINWATER_MITRE_INTERNAL, ORDER_TAB_RAINWATER_MITRE_EXTERNAL } from '../../../../common/constant'
import { Button, Modal } from 'react-bootstrap-v5'
import { SHIPPING_TYPES } from '../../../../../utils'

const RainwaterGoods = () => {
  const { rainWaterSetup, rainwaterProductMasters, addToCart, cartItems } = useContext(QuickOrderContext)
  const dataShipping = JSON.parse(localStorage.getItem('shipping-preference') as any) || {}
  let rainWaterCategory = ['Gutter']

  const getRainWaterStylePM = (category: string) => {
    const availStyle: any = rainwaterProductMasters.filter((x: any) => x.rainwaterPartName.toUpperCase().includes(category.toUpperCase()))

    return availStyle || []
  }

  const getRainWaterStyleMitreInternal = () => {
    const availStyle: any = rainwaterProductMasters.filter((x: any) =>
      x.rainwaterPartName.toLowerCase().includes(ORDER_TAB_RAINWATER_MITRE_INTERNAL.toLowerCase()))

    return availStyle || []
  }

  const getRainWaterStyleMitreExternal = () => {
    const availStyle: any = rainwaterProductMasters.filter((x: any) =>
      x.rainwaterPartName.toLowerCase().includes(ORDER_TAB_RAINWATER_MITRE_EXTERNAL.toLowerCase()))

    return availStyle || []
  }


  const getRainWaterStyleBracketStopEnd = (category: string) => {
    const availStyle: any = rainwaterProductMasters.filter((x: any) =>
      x.rainwaterPartName.toLowerCase().includes('gutter bracket') ||
      x.rainwaterPartName.toLowerCase().includes('gutter stop end') ||
      x.rainwaterPartName.toLowerCase().includes('gutter dropper') ||
      x.rainwaterPartName.toLowerCase().includes('gutter overstrap'))

    return availStyle || []
  }


  const getRainWaterColourStopEnd = (category: string) => {
    const availStyle: any = rainwaterProductMasters.filter((x: any) =>
      x.rainwaterPartName.toLowerCase().includes('gutter stop end'))

    return availStyle || []
  }

  const getRainWaterColourMitreInternal = () => {
    const availStyle: any = rainwaterProductMasters.filter((x: any) =>
      x.rainwaterPartName.toLowerCase().includes(ORDER_TAB_RAINWATER_MITRE_INTERNAL.toLowerCase()))

    return availStyle || []
  }

  const getRainWaterColourMitreExternal = () => {
    const availStyle: any = rainwaterProductMasters.filter((x: any) =>
      x.rainwaterPartName.toLowerCase().includes(ORDER_TAB_RAINWATER_MITRE_EXTERNAL.toLowerCase()))

    return availStyle || []
  }

  const [error, setError] = useState<boolean>(false)
  const [errorMsg, setErrorMsg] = useState<string>('')

  const [selectedGutterItem, setSelectedGutterItem] = useState<any>({})
  const [selectedGutterItemForStopEndBracket, setSelectedGutterItemForStopEndBracket] = useState<any>({})
  const [selectedGutterItemForMitreInternal, setSelectedGutterItemForMitreInternal] = useState<any>({})
  const [selectedGutterItemForMitreExternal, setSelectedGutterItemForMitreExternal] = useState<any>({})

  const [gutterDropperQuantity, setGutterDropperQuantity] = useState<any>()
  const [gutterOverstrapQuantity, setGutterOverstrapQuantity] = useState<any>()
  const [gutterBracketQuantity, setGutterBracketQuantity] = useState<any>()
  const [stopEndQuantity, setStopEndQuantity] = useState<any>()
  const [stopEndPrice, setStopEndPrice] = useState<any>()
  const [stopEndColor, setStopEndColor] = useState<number>(0)
  const [stopEndColourId, setStopEndColourId] = useState<number>(0)
  const [stopEndColorName, setStopEndColorName] = useState<number>(0)

  const [mitreInternalQuantity, setMitreInternalQuantity] = useState<any>()
  const [mitreExternalQuantity, setMitreExternalQuantity] = useState<any>()
  const [mitreInternalPrice, setMitreInternalPrice] = useState<any>()
  const [mitreExternalPrice, setMitreExternalPrice] = useState<any>()
  const [mitreInternalColor, setMitreInternalColor] = useState<number>(0)
  const [mitreExternalColor, setMitreExternalColor] = useState<number>(0)
  const [mitreInternalColourId, setMitreInternalColourId] = useState<number>(0)
  const [mitreExternalColourId, setMitreExternalColourId] = useState<number>(0)
  const [mitreInternalColorName, setMitreInternalColorName] = useState<number>(0)
  const [mitreExternalColorName, setMitreExternalColorName] = useState<number>(0)

  const [gutterBracketPrice, setGutterBracketPrice] = useState<any>()
  const [gutterDropperPrice, setGutterDropperPrice] = useState<any>()
  const [gutterOverstrapPrice, setGutterOverstrapPrice] = useState<any>()

  const [isGutterChecked, setIsGutterChecked] = useState(false)
  const [isStopEndChecked, setIsStopEndChecked] = useState(false)
  const [isMitreInternalChecked, setIsMitreInternalChecked] = useState(false)
  const [isMitreExternalChecked, setIsMitreExternalChecked] = useState(false)
  const [isGutterBracketChecked, setIsGutterBracketChecked] = useState(false)
  const [isGutterDropperChecked, setIsGutterDropperChecked] = useState(false)
  const [isGutterOverstrapChecked, setIsGutterOverstrapChecked] = useState(false)

  const [selectedColourId, setSelectedColourId] = useState<number>(0)

  //New gutter
  const [gutterItem, setGutterItem] = useState<any>({})
  const [newGutterPricingId, setNewGutterPricingId] = useState(0)
  const [color, setColor] = useState<number>(0)
  const [colorName, setColorName] = useState<number>(0)
  const [length, setLength] = useState<any>()
  const [quantity, setQuantity] = useState<any>()
  const [gutter, setGutter] = useState<any>('Select Gutter Name')
  const [price, setPrice] = useState(0)
  const maxQuantity = 1000000

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const resetRainwaterState = () => {
    resetGutter()
    resetStopend()
    resetBracket()
    resetDropper()
    resetOvertstrap()
  }

  const resetGutter = () => {
    //gutter
    setLength('')
    setQuantity(0)
    setStopEndQuantity('')
    setGutterBracketQuantity('')
  }

  const resetStopend = () => {
    //stopend
    setStopEndQuantity('')
  }

  const resetBracket = () => {
    //bracket
    setGutterBracketQuantity('')
  }

  const resetDropper = () => {
    //Dropper
    setGutterDropperQuantity('')
  }

  const resetOvertstrap = () => {
    //Overstrap
    setGutterOverstrapQuantity('')
  }

  const resetMitreInternal = () => {
    //mitre internal
    setMitreInternalQuantity('')
  }

  const resetMitreExternal = () => {
    //mitre external
    setMitreExternalQuantity('')
  }

  const GutterAddToCart = () => {
    // ADD TO CART
    if (length >= 9000 && dataShipping?.shipping == SHIPPING_TYPES.DELIVERY) {
      handleShow();
    }


    addToCart({
      ...gutterItem,
      color,
      colorName,
      gutterName: gutterItem?.rainwaterStyleName,
      length,
      quantity,
      customId: Math.random(),
      type: 'gutter',
      uniqueID: `gutter-${color}-${gutterItem?.rainwaterStyleName}-${gutterItem?.rainwaterStyleName}-${Math.random().toString(36).substring(2, 15)}`,
      pricingId: newGutterPricingId,
      unitPrice: gutterItem.priceLevel1,
      price: gutterItem.priceLevel1,
      productType: ORDER_LIST_RAINWATERGOODS,
      productName: gutterItem?.rainwaterStyleName,
      description: colorName,
    })
    resetGutter()
  }

  const StopEndAddToCart = () => {
    // ADD TO CART
    addToCart({
      ...stopEndPrice,
      pricingId: stopEndPrice.id,
      unitPrice: stopEndPrice.priceLevel1,
      price: stopEndPrice.priceLevel1,
      gutterName: `${stopEndPrice?.rainwaterStyleName} ${stopEndPrice?.rainwaterPartName}`,
      quantity: stopEndQuantity,
      color: stopEndColor,
      colorName: stopEndColorName,
      customId: Math.random(),
      type: 'stop-end-bracket',
      uniqueID: `stop-end-bracket-${stopEndPrice?.rainwaterStyleName}-${stopEndPrice?.rainwaterPartName}-${stopEndQuantity}-${Math.random().toString(36).substring(2, 15)}-${getUniqueIdWithPrefix('stop-end-bracket')}`.replace(/\s/g, ''),
      productType: ORDER_LIST_RAINWATERGOODS,
      productName: `${stopEndPrice?.rainwaterStyleName} ${stopEndPrice?.rainwaterPartName}`,
      description: stopEndColorName,
    })
    resetStopend()
  }

  const BracketAddToCart = () => {
    // ADD TO CART
    addToCart({
      ...gutterBracketPrice,
      pricingId: gutterBracketPrice.id,
      price: gutterBracketPrice.priceLevel1,
      unitPrice: gutterBracketPrice.priceLevel1,
      gutterName: `${gutterBracketPrice?.rainwaterStyleName} ${gutterBracketPrice?.rainwaterPartName}`,
      quantity: gutterBracketQuantity,
      color: 0,
      colorName: '',
      customId: Math.random(),
      type: 'stop-end-bracket',
      uniqueID: `stop-end-bracket-${gutterBracketPrice?.rainwaterStyleName}-${gutterBracketPrice?.rainwaterPartName}-${gutterBracketQuantity}-${Math.random().toString(36).substring(2, 15)}-${getUniqueIdWithPrefix('stop-end-bracket')}`.replace(/\s/g, ''),
      productType: ORDER_LIST_RAINWATERGOODS,
      productName: `${gutterBracketPrice?.rainwaterStyleName} ${gutterBracketPrice?.rainwaterPartName}`,
      description: '-',
    })
    resetBracket()
  }

  const DropperAddToCart = () => {
    // ADD TO CART
    addToCart({
      ...gutterDropperPrice,
      pricingId: gutterDropperPrice.id,
      price: gutterDropperPrice.priceLevel1,
      unitPrice: gutterDropperPrice.priceLevel1,
      gutterName: gutterDropperPrice?.rainwaterPartName,
      quantity: gutterDropperQuantity,
      color: 0,
      colorName: '',
      customId: Math.random(),
      type: 'stop-end-bracket',
      uniqueID: `stop-end-bracket-${gutterDropperPrice?.rainwaterStyleName ? gutterDropperPrice?.rainwaterStyleName : ''}-${gutterDropperPrice?.rainwaterPartName}-${gutterDropperPrice}-${Math.random().toString(36).substring(2, 15)}-${getUniqueIdWithPrefix('stop-end-bracket')}`.replace(/\s/g, ''),
      productType: ORDER_LIST_RAINWATERGOODS,
      productName: gutterDropperPrice?.rainwaterPartName,
      description: '-',
    })
    resetDropper()
  }

  const OverstrapAddToCart = () => {
    // ADD TO CART
    addToCart({
      ...gutterOverstrapPrice,
      pricingId: gutterOverstrapPrice.id,
      price: gutterOverstrapPrice.priceLevel1,
      unitPrice: gutterOverstrapPrice.priceLevel1,
      gutterName: gutterOverstrapPrice?.rainwaterPartName,
      quantity: gutterOverstrapQuantity,
      color: 0,
      colorName: '',
      customId: Math.random(),
      type: 'stop-end-bracket',
      uniqueID: `stop-end-bracket-${gutterOverstrapPrice?.rainwaterStyleName ? gutterOverstrapPrice?.rainwaterStyleName : ''}-${gutterOverstrapPrice?.rainwaterPartName}-${gutterOverstrapPrice}-${Math.random().toString(36).substring(2, 15)}-${getUniqueIdWithPrefix('stop-end-bracket')}`.replace(/\s/g, ''),
      productType: ORDER_LIST_RAINWATERGOODS,
      productName: gutterOverstrapPrice?.rainwaterPartName,
      description: '-',
    })
    resetOvertstrap()
  }

  //same scenario/ handling with stop end
  const MitreInternalAddToCart = () => {
    // ADD TO CART
    addToCart({
      ...mitreInternalPrice,
      pricingId: mitreInternalPrice.id,
      unitPrice: mitreInternalPrice.priceLevel1,
      price: mitreInternalPrice.priceLevel1,
      gutterName: `${mitreInternalPrice?.rainwaterStyleName} ${mitreInternalPrice?.rainwaterPartName}`,
      quantity: mitreInternalQuantity,
      color: mitreInternalColor,
      colorName: mitreInternalColorName,
      customId: Math.random(),
      type: 'stop-end-bracket',
      uniqueID: `stop-end-bracket-${mitreInternalPrice?.rainwaterStyleName}-${mitreInternalPrice?.rainwaterPartName}-${mitreInternalQuantity}-${Math.random().toString(36).substring(2, 15)}-${getUniqueIdWithPrefix('stop-end-bracket')}`.replace(/\s/g, ''),
      productType: ORDER_LIST_RAINWATERGOODS,
      productName: `${mitreInternalPrice?.rainwaterStyleName} ${mitreInternalPrice?.rainwaterPartName}`,
      description: mitreInternalColorName,
    })
    resetMitreInternal()
  }

  const MitreExternalAddToCart = () => {
    // ADD TO CART
    addToCart({
      ...mitreExternalPrice,
      pricingId: mitreExternalPrice.id,
      unitPrice: mitreExternalPrice.priceLevel1,
      price: mitreExternalPrice.priceLevel1,
      gutterName: `${mitreExternalPrice?.rainwaterStyleName} ${mitreExternalPrice?.rainwaterPartName}`,
      quantity: mitreExternalQuantity,
      color: mitreExternalColor,
      colorName: mitreExternalColorName,
      customId: Math.random(),
      type: 'stop-end-bracket',
      uniqueID: `stop-end-bracket-${mitreExternalPrice?.rainwaterStyleName}-${mitreExternalPrice?.rainwaterPartName}-${mitreExternalQuantity}-${Math.random().toString(36).substring(2, 15)}-${getUniqueIdWithPrefix('stop-end-bracket')}`.replace(/\s/g, ''),
      productType: ORDER_LIST_RAINWATERGOODS,
      productName: `${mitreExternalPrice?.rainwaterStyleName} ${mitreExternalPrice?.rainwaterPartName}`,
      description: mitreExternalColorName,
    })
    resetMitreExternal()
  }

  // useEffect(() => {
  //   if (!isGutterChecked) {
  //     resetGutter()
  //     setColor(0)
  //     setSelectedColourId(0)
  //     setGutter('Select Gutter Name')
  //     setPrice(0)
  //     setGutterItem({})
  //     setStopEndPrice(0)
  //     setGutterBracketPrice(0)
  //     setIsStopEndChecked(false)
  //     setIsGutterBracketChecked(false)
  //   }
  // },[isGutterChecked])

  useEffect(() => {
    setStopEndColourId(selectedColourId)
    setStopEndColor(color)
    setStopEndColorName(colorName)

    setMitreInternalColor(selectedColourId)
    setMitreInternalColourId(color)
    setMitreInternalColorName(colorName)

    setMitreExternalColor(selectedColourId)
    setMitreExternalColourId(color)
    setMitreExternalColorName(colorName)
  }, [selectedColourId])

  useEffect(() => {
    if (!isStopEndChecked) {
      resetStopend()
      setIsStopEndChecked(false)
    }
  }, [isStopEndChecked])

  useEffect(() => {
    if (!isGutterBracketChecked) {
      resetBracket()
    }
  }, [isGutterBracketChecked])

  useEffect(() => {
    if (!isGutterDropperChecked) {
      resetDropper()
    }
  }, [isGutterDropperChecked])

  useEffect(() => {
    if (!isGutterOverstrapChecked) {
      resetOvertstrap()
    }
  }, [isGutterOverstrapChecked])

  const disabledGutter =
    color === 0 ||
    isNaN(quantity) ||
    quantity === 0 ||
    quantity < 0 ||
    length === '' ||
    isNaN(length) ||
    length === 0 ||
    length < 0 ||
    length < 100 ||
    length > 23000 ||
    !price
  const disabledStopEnd =
    !isStopEndChecked ||
    !stopEndPrice ||
    stopEndQuantity === '' ||
    stopEndColor === 0 ||
    isNaN(stopEndQuantity) ||
    isNaN(stopEndQuantity)
  const disabledGutterBracket =
    !isGutterBracketChecked ||
    !gutterBracketPrice ||
    gutterBracketQuantity === '' ||
    isNaN(gutterBracketQuantity)
  const disabledGutterDropper =
    !isGutterDropperChecked ||
    !gutterDropperPrice ||
    gutterDropperQuantity === '' ||
    isNaN(gutterDropperQuantity)
  const disabledGutterOverstrap =
    !isGutterOverstrapChecked ||
    !gutterOverstrapPrice ||
    gutterOverstrapQuantity === '' ||
    isNaN(gutterOverstrapQuantity)
  const disabledMitreInternal =
    !isMitreInternalChecked ||
    !mitreInternalPrice ||
    mitreInternalQuantity === '' ||
    mitreInternalColor === 0 ||
    isNaN(mitreInternalQuantity)
  const disabledMitreExternal =
    !isMitreExternalChecked ||
    !mitreExternalPrice ||
    mitreExternalQuantity === '' ||
    mitreExternalColor === 0 ||
    isNaN(mitreExternalQuantity)

  const disabled = (
    (!isGutterChecked && !isStopEndChecked && !isGutterBracketChecked && !isGutterDropperChecked &&
      !isGutterOverstrapChecked && !isMitreInternalChecked && !isMitreExternalChecked) ||
    (isGutterChecked && disabledGutter) ||
    (isStopEndChecked && disabledStopEnd) ||
    (isGutterBracketChecked && disabledGutterBracket) ||
    (isGutterDropperChecked && disabledGutterDropper) ||
    (isGutterOverstrapChecked && disabledGutterOverstrap) ||
    (isMitreInternalChecked && disabledMitreInternal) ||
    (isMitreExternalChecked && disabledMitreExternal)
  )

  const handleGutterStopendBracketAddToCart = () => {
    if (isGutterChecked && !disabledGutter) {
      GutterAddToCart()
    }

    if (isStopEndChecked && !disabledStopEnd) {
      StopEndAddToCart()
    }

    if (isGutterBracketChecked && !disabledGutterBracket) {
      BracketAddToCart()
    }

    if (isGutterDropperChecked && !disabledGutterDropper) {
      DropperAddToCart()
    }

    if (isGutterOverstrapChecked && !disabledGutterOverstrap) {
      OverstrapAddToCart()
    }

    if (isMitreInternalChecked && !disabledMitreInternal) {
      MitreInternalAddToCart()
    }

    if (isMitreExternalChecked && !disabledMitreExternal) {
      MitreExternalAddToCart()
    }
  }

  return (
    <div className='d-flex flex-column justify-content-between' style={{ overflow: 'hidden' }}>
      <div style={{ overflowY: 'scroll', overflowX: 'hidden', height: '80vh' }}>
        {rainwaterProductMasters && rainWaterCategory.map((waterCategory: string) => (
          <React.Fragment key={waterCategory}>
            <h3 style={{ backgroundColor: '#e5e5e5', borderRadius: '0.475rem' }} className='p-2'>
              {waterCategory}
            </h3>
            <React.Fragment key={waterCategory}>
              {error ? (
                <div className='alert alert-danger w-25 m-auto text-center' role='alert'>
                  {errorMsg}
                </div>
              ) : null}
              <div className='my-4'>
                <NewGutterItem
                  setError={setError}
                  setErrorMsg={setErrorMsg}
                  items={getRainWaterStylePM(waterCategory)}
                  pricings={getRainWaterStylePM(waterCategory)}
                  categoryName={waterCategory}
                  setSelectedGutterItem={(item: any) => {
                    setSelectedGutterItem({ ...item })
                  }}
                  setSelectedGutterItemForStopEndBracket={(item: any) => {
                    setSelectedGutterItemForStopEndBracket({ ...item })
                  }}
                  setSelectedGutterItemForMitreInternal={(item: any) => {
                    setSelectedGutterItemForMitreInternal({ ...item })
                  }}
                  setSelectedGutterItemForMitreExternal={(item: any) => {
                    setSelectedGutterItemForMitreExternal({ ...item })
                  }}
                  setGutterBracketQuantity={setGutterBracketQuantity}
                  setStopEndQuantity={setStopEndQuantity}
                  stopEndPrice={stopEndPrice}
                  gutterBracketPrice={gutterBracketPrice}
                  setStopEndPrice={setStopEndPrice}
                  setGutterBracketPrice={setGutterBracketPrice}
                  setIsGutterBracketChecked={setIsGutterBracketChecked}
                  setIsStopEndChecked={setIsStopEndChecked}
                  setIsGutterDropperChecked={setIsGutterDropperChecked}
                  categoryId={waterCategory}
                  setColourId={(colourId: number) => {
                    setSelectedColourId(colourId)
                  }}
                  gutterItem={gutterItem}
                  setGutterItem={setGutterItem}
                  newGutterPricingId={newGutterPricingId}
                  setNewGutterPricingId={setNewGutterPricingId}
                  color={color}
                  setColor={setColor}
                  colorName={colorName}
                  setColorName={setColorName}
                  length={length}
                  setLength={setLength}
                  quantity={quantity}
                  setQuantity={setQuantity}
                  gutter={gutter}
                  setGutter={setGutter}
                  price={price}
                  setPrice={setPrice}
                  isGutterChecked={isGutterChecked}
                  setIsGutterChecked={setIsGutterChecked}
                  disabled={disabled}
                  handleGutterStopendBracketAddToCart={handleGutterStopendBracketAddToCart}
                />
                <NewStopEndBracketItem
                  items={getRainWaterColourStopEnd(waterCategory)}
                  pricings={getRainWaterStyleBracketStopEnd(waterCategory)}
                  selectedGutterItem={selectedGutterItem}
                  setSelectedGutterItem={setSelectedGutterItem}
                  selectedGutterItemForStopEndBracket={selectedGutterItemForStopEndBracket}
                  setGutterBracketQuantity={setGutterBracketQuantity}
                  setStopEndQuantity={setStopEndQuantity}
                  setStopEndPrice={setStopEndPrice}
                  setGutterBracketPrice={setGutterBracketPrice}
                  gutterBracketQuantity={gutterBracketQuantity}
                  stopEndQuantity={stopEndQuantity}
                  stopEndPrice={stopEndPrice}
                  gutterBracketPrice={gutterBracketPrice}
                  setIsStopEndChecked={setIsStopEndChecked}
                  setIsGutterBracketChecked={setIsGutterBracketChecked}
                  setIsGutterDropperChecked={setIsGutterDropperChecked}
                  setGutterDropperPrice={setGutterDropperPrice}
                  gutterDropperPrice={gutterDropperPrice}
                  isGutterDropperChecked={isGutterDropperChecked}
                  gutterDropperQuantity={gutterDropperQuantity}
                  setGutterDropperQuantity={setGutterDropperQuantity}
                  setIsGutterOverstrapChecked={setIsGutterOverstrapChecked}
                  setGutterOverstrapPrice={setGutterOverstrapPrice}
                  gutterOverstrapPrice={gutterOverstrapPrice}
                  isGutterOverstrapChecked={isGutterOverstrapChecked}
                  gutterOverstrapQuantity={gutterOverstrapQuantity}
                  setGutterOverstrapQuantity={setGutterOverstrapQuantity}
                  isStopEndChecked={isStopEndChecked}
                  isGutterBracketChecked={isGutterBracketChecked}
                  stopEndColor={stopEndColor}
                  setStopEndColor={setStopEndColor}
                  stopEndColourId={stopEndColourId}
                  setStopEndColourId={setStopEndColourId}
                  stopEndColorName={stopEndColorName}
                  setStopEndColorName={setStopEndColorName}
                />
                <NewGutterMitreItem
                  mitreInternalItems={getRainWaterColourMitreInternal()}
                  mitreInternalPricings={getRainWaterStyleMitreInternal()}
                  selectedGutterItem={selectedGutterItem}
                  selectedGutterItemForMitreInternal={selectedGutterItemForMitreInternal}
                  mitreInternalQuantity={mitreInternalQuantity}
                  setMitreInternalQuantity={setMitreInternalQuantity}
                  mitreInternalPrice={mitreInternalPrice}
                  setMitreInternalPrice={setMitreInternalPrice}
                  setIsMitreInternalChecked={setIsMitreInternalChecked}
                  isMitreInternalChecked={isMitreInternalChecked}
                  mitreInternalColor={mitreInternalColor}
                  setMitreInternalColor={setMitreInternalColor}
                  mitreInternalColourId={mitreInternalColourId}
                  setMitreInternalColourId={setMitreInternalColourId}
                  mitreInternalColorName={mitreInternalColorName}
                  setMitreInternalColorName={setMitreInternalColorName}
                  mitreExternalItems={getRainWaterColourMitreExternal()}
                  mitreExternalPricings={getRainWaterStyleMitreExternal()}
                  selectedGutterItemForMitreExternal={selectedGutterItemForMitreExternal}
                  mitreExternalQuantity={mitreExternalQuantity}
                  setMitreExternalQuantity={setMitreExternalQuantity}
                  mitreExternalPrice={mitreExternalPrice}
                  setMitreExternalPrice={setMitreExternalPrice}
                  setIsMitreExternalChecked={setIsMitreExternalChecked}
                  isMitreExternalChecked={isMitreExternalChecked}
                  mitreExternalColor={mitreExternalColor}
                  setMitreExternalColor={setMitreExternalColor}
                  mitreExternalColourId={mitreExternalColourId}
                  setMitreExternalColourId={setMitreExternalColourId}
                  mitreExternalColorName={mitreExternalColorName}
                  setMitreExternalColorName={setMitreExternalColorName}
                />
              </div>
            </React.Fragment>
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header>
                <Modal.Title>Delivery Notice</Modal.Title>
                <button type='button' className='btn-close' onClick={handleClose}></button>
              </Modal.Header>
              <Modal.Body>
                <p>Orders with a length of 9000mm or more require delivery by semi‑truck. Please ensure your location can accommodate this type of vehicle before proceeding.</p>
              </Modal.Body>
              <Modal.Footer>
                {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button> */}
                <Button variant="primary" onClick={handleClose}>
                  Ok
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default RainwaterGoods
